'use client';

// based on https://www.radix-ui.com/primitives/docs/components/label#api-reference

import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';
import styles from './label.module.scss';

const labelVariants = cva(styles.label, {
  variants: {
    size: {
      medium: styles.medium,
      large: styles.large
    }
  },
  defaultVariants: {
    size: 'medium'
  }
});

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants>
>(({ className, size, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={labelVariants({ className, size })}
    {...props}
  />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
